import { makeStyles, Typography } from "@bb-ui/react-library";
import { Grid } from "@material-ui/core";
import { FunctionComponent } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 100,
  },
  logo: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(4),
  },
  image: {
    maxWidth: 100,
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  message: {
    marginBottom: theme.spacing(4),
  },
}));

export interface ErrorWidgetProps {
  title?: string;
  message?: string;
}

export const ErrorWidget: FunctionComponent<ErrorWidgetProps> = ({
  message,
  title,
}) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      className={classes.root}
      justifyContent={"space-around"}
    >
      <Grid item>
        <Grid container direction="column" alignItems="center">
          <Typography
            className={classes.title}
            variant={"h1"}
            data-test="error-title"
          >
            {title}
          </Typography>
          <Typography
            className={classes.message}
            variant={"subtitle2"}
            data-test="error-message"
          >
            {message}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
